import { QueryParams } from './types';

export const scheduleListKeys = {
  lists: () => ['SCHEDULE_LIST'] as const, // list of all items
  list: (filters: QueryParams) =>
    [...scheduleListKeys.lists(), { filters }] as const, // list of items with specific filters,
};
